import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M29.68 12.5l-4-3.37V3.5a.65.65 0 0 0-.68-.65H7a.65.65 0 0 0-.65.65v5.6l-4 3.37a2.59 2.59 0 0 0-1 2v12a2.73 2.73 0 0 0 2.8 2.65h23.7a2.73 2.73 0 0 0 2.8-2.65v-12a2.56 2.56 0 0 0-.97-1.97zm-1.45.5l-2.58 1.94V10.8zM7.65 4.15h16.7V15.5a.6.6 0 0 0 .1.32L16 22.18l-8.43-6.39a.57.57 0 0 0 .08-.29zm-1.3 10.71l-2.53-1.92 2.53-2.14zm23 11.64a1.43 1.43 0 0 1-1.5 1.35H4.15a1.43 1.43 0 0 1-1.5-1.35v-12a1.22 1.22 0 0 1 .2-.67l12.76 9.69a.66.66 0 0 0 .78 0l12.79-9.64a1.23 1.23 0 0 1 .17.62z' }),
  React.createElement('path', { d: 'M11 6.85h10v1.3H11zM11 10.85h10v1.3H11zM11 14.85h10v1.3H11z' })
));